export const brandToCaseMap = {
  seek: 'SEEK',
  jobsdb: 'Jobsdb',
  jobstreet: 'Jobstreet',
} as const;

export const poeaTerms = ['poea', 'overseas', 'dmw', 'abroad'];
